var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.29 6.71a3.85 3.85 0 0 0-1.18-2.82 3.85 3.85 0 0 0-2.82-1.18c-1.11 0-2.05.4-2.83 1.18a3.84 3.84 0 0 0-1.17 2.82c0 1.11.39 2.05 1.17 2.83s1.72 1.17 2.83 1.17a3.84 3.84 0 0 0 2.82-1.17c.78-.78 1.18-1.72 1.18-2.83zm4.57 7.43c0 .31-.12.58-.34.81-.23.22-.5.34-.81.34-.32 0-.58-.12-.8-.34l-3.06-3.06C8.78 12.63 7.6 13 6.29 13c-.86 0-1.67-.17-2.45-.5-.77-.33-1.44-.77-2.01-1.33-.56-.57-1-1.24-1.33-2.01C.17 8.38 0 7.57 0 6.71c0-.85.17-1.66.5-2.44.33-.77.77-1.44 1.33-2.01A6.49 6.49 0 0 1 3.84.92C4.62.59 5.43.43 6.29.43c.85 0 1.66.16 2.44.49a6.49 6.49 0 0 1 2.01 1.34 6.49 6.49 0 0 1 1.34 2.01c.33.78.49 1.59.49 2.44 0 1.31-.37 2.5-1.11 3.57l3.07 3.06c.22.22.33.49.33.8z"}));
}

Search.defaultProps = {"viewBox":"0 0 15 16"};

module.exports = Search;

Search.default = Search;
